/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import ReactConfetti from 'react-confetti';

const Confetti = () => {
  return <ReactConfetti />;
};

export default Confetti;
